export enum ApplicationMode {
  All = 'All',
  Include = 'Include',
  Exclude = 'Exclude',
}